export const crosshair = {
  width: 8, // cant use variable as this needs number
  color: 'var(--blue-10)',
  zIndex: 1,
};

export const TOGGLE_CHART_LABEL_LOCALSTORAGE_KEY = 'toggle.chart.labels';
